module.exports = __webpack_public_path__ + "static/media/whatsApp.64940ed8.png";